"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var error = {
  light: '#f8d2d2',
  main: '#d90606',
  dark: '#800000'
};
exports["default"] = error;